import React from "react";
import {
  Drawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import DrawerHeader, { DRAWER_NO_SLIDE, DRAWER_PAPER_PROPS } from "./DrawerHeader";
import DoneIcon from "@mui/icons-material/Done";
import BlockIcon from "@mui/icons-material/Block";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PluginFilter from "./PluginFilter";
import { useState,useMemo } from "react";

const PluginDrawer = ({
  selectedRowIndex,
  displayedPlugins,
  handleCloseDrawer,
  role
}) => {
  const theme = useTheme();
  const [filterInstance, setFilterInstance] = useState("all");

  const handleFilterInstanceChange = (instanceName) => {
    setFilterInstance(instanceName);
  };

  // Mémoïsé et placé avant l'early return pour respecter l'ordre des hooks : le filtre
  // et la recherche de version tombaient sinon dans la frame d'ouverture du Drawer.
  const details = useMemo(() => {
    if (
      selectedRowIndex == null ||
      selectedRowIndex >= displayedPlugins.length
    ) {
      return null;
    }

    // Récupération du plugin sélectionné
    const pluginData = displayedPlugins[selectedRowIndex];
    const sites = pluginData.sites || [];

    // Chercher la première version valide
    let firstValidVersion = "Non spécifiée";
    for (const site of sites) {
      if (site.lastVersionPLUG && site.lastVersionPLUG !== "Non spécifiée") {
        firstValidVersion = site.lastVersionPLUG;
        break;
      }
    }

    return {
      name: pluginData.name,
      firstValidVersion,
      filteredSites: sites.filter(
        (site) => filterInstance === "all" || site.env === filterInstance
      ),
    };
  }, [displayedPlugins, selectedRowIndex, filterInstance]);

  if (!details) {
    return null;
  }

  const { filteredSites, firstValidVersion } = details;


  // Vérifie si le plugin est actif
  const checkIsActive = (active) =>
    active === 1 || active === "1" || active === true;
  
  
  return (
    <Drawer
      anchor="right"
      open={selectedRowIndex != null}
      onClose={() => {
          handleCloseDrawer();

          setTimeout(() => {
            setFilterInstance("all");
          }, 1000);
        }}
      PaperProps={DRAWER_PAPER_PROPS.wide}
      SlideProps={DRAWER_NO_SLIDE}
      // Sans ça, le scroll lock de MUI pose overflow:hidden + padding-right sur
      // <body> à l'ouverture, ce qui relayoute tout le dashboard pendant l'animation.
      disableScrollLock
    >
      <div>
        <DrawerHeader
          title={details.name}
          subtitle={`Dernière version : ${firstValidVersion}`}
          actions={
            <PluginFilter
              data={displayedPlugins}
              onFilterChange={handleFilterInstanceChange}
              role={role}
            />
          }
          onClose={handleCloseDrawer}
          role={role}
        />

        {/* Contenu du drawer (tableau) */}
        <div className="drawerTab">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Active</TableCell>
                  <TableCell>Site</TableCell>
                  <TableCell align="center">URL</TableCell>
                  <TableCell align="center">Env</TableCell>
                  <TableCell align="center">Service</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold" }}>
                    Version
                  </TableCell>
                  <TableCell align="center">Mise à jour</TableCell>
                </TableRow>
              </TableHead>
                            <TableBody>
                {filteredSites.map((site, index) => (
                  <TableRow key={index} sx={{
                    backgroundColor: index % 2 === 0
                      ? theme.palette.background.alternate
                      : theme.palette.background.paper,
                  }}>
                    <TableCell align="center">{checkIsActive(site.active) ? <DoneIcon style={{ color: "green" }} /> : <BlockIcon style={{ color: "red" }} />}</TableCell>
                    <TableCell align="left">{site.site}</TableCell>
                    <TableCell align="center">
                      {site.siteUrl && (
                        <span style={{ display: "flex", cursor: "pointer" }}>
                          <OpenInNewIcon />
                          <a href={site.siteUrl} style={{ paddingLeft: "5px", position: "relative", top: "3px" }} target="_blank" rel="noopener noreferrer">
                            {site.siteUrl}
                          </a>
                        </span>
                      )}
                    </TableCell>
                    <TableCell align="center">{site.env}</TableCell>
                    <TableCell align="center">{site.selectedService || site["selected-service"] || "N/A"}</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>{site.versionplugins}</TableCell>
                    <TableCell align="center">{site.updateModePLUG}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </Drawer>
  );
};

export default PluginDrawer;
